import { createMintSocketBuilder } from '@mint-lib/api-zod-support/socket';
import { z } from 'zod';

import { ProcessItemStatusesEnum } from '../executionLayer/schemas.js';
import { EntitySourcesEnum, FlowTypesEnum } from '../shared/schemas/index.js';

export const approvalSocket = createMintSocketBuilder({
  onValidationError: (error) => {
    console.error(error);
  },
});

const tileRoomPayloadSchema = z.object({
  companyId: z.string(),
  approvalItemId: z.string(),
  approvalItemType: z.string(),
});

export const enterTileRoom = approvalSocket.defineSend({
  topic: 'enter_tile_room',
  payloadSchema: tileRoomPayloadSchema,
});

export const leaveTileRoom = approvalSocket.defineSend({
  topic: 'leave_tile_room',
  payloadSchema: tileRoomPayloadSchema,
});

export const approvalStatusUpdatedPayloadSchema = z.object({
  requestId: z.string(),
  entityType: FlowTypesEnum,
  entityId: z.string(),
  entitySource: EntitySourcesEnum,
  status: ProcessItemStatusesEnum,
});

export const onApprovalStatusUpdated = approvalSocket.defineSubscribe({
  topic: 'v2.approval_status_updated',
  payloadSchema: approvalStatusUpdatedPayloadSchema,
});
